import React from 'react';
import {observer} from 'mobx-react';

import HicapsBadge from 'core/components/HicapsBadge.js';
import {PracticeStoreContext} from 'core/stores/RootStore.js';
import LocationList from 'practices/components/LocationList.js';
import PracticeFAQ from 'practices/components/PracticeFAQ.js';
import PracticeOverview from 'practices/components/PracticeOverview.js';
import PracticeRelatedInfo from 'practices/components/PracticeRelatedInfo.js';
import PractitionerList from 'practices/components/PractitionerList.js';

@observer
export default class PracticeContent extends React.Component {
    static contextType = PracticeStoreContext;
    tabPanels = {
        LocationList,
        PracticeOverview,
        PracticeRelatedInfo,
        PracticeFAQ,
        PractitionerList,
    };

    renderHicaps() {
        const {activeTab, practice, isPracticeGroup} = this.context;

        const isLocationTab = activeTab?.hash === 'locations';
        if (activeTab === null || !isPracticeGroup || !isLocationTab) {
            return null;
        }

        const offersHicaps = practice.locations?.find(
            (prac) => prac.offersHicaps,
        );
        if (offersHicaps) {
            return (
                <div>
                    <HicapsBadge />
                </div>
            );
        }

        return null;
    }

    renderComponent() {
        const {activeTab, displayTabsOnPage} = this.context;
        if (activeTab == null) {
            if (displayTabsOnPage) {
                return null;
            } else {
                return <PracticeOverview />;
            }
        } else {
            const Component = this.tabPanels[activeTab.component];
            return <Component />;
        }
    }

    render() {
        const {practiceLoaded} = this.context;
        if (!practiceLoaded) {
            return null;
        }
        return (
            <section className="main-content" role="tabpanel">
                {this.renderHicaps()}
                {this.renderComponent()}
            </section>
        );
    }
}
